import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_API_URL;

export const Api = {
  getCsrfToken: async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/get-csrf-token`, {
        withCredentials: true,
      });
      return response.data.csrf_token;
    } catch (e) {
      console.error('Error fetching CSRF token:', e);
      throw new Error('Failed to get CSRF token.');
    }
  },


  submitTitle: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/get-lien-titleV2`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  downloadTitleOutput: async (data) => {
  try {
    const csrfToken = await Api.getCsrfToken();
    const response = await axios.get(`${SERVER_URL}/api/get-lien-title-pdf`, {
      headers: {
        'X-CSRFToken': csrfToken,
      },
      // Only our transaction ID: the server looks up the Yassi ID on the
      // user's own record and mints the Yassi token itself.
      params: {
        transaction_id: data?.['Transaction ID'],
      },
      withCredentials: true,
      responseType: 'blob',
    });

    if (response.status === 200) {
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;

      const fileName = data['Transaction ID'] ? `${data['Transaction ID']}.pdf` : 'titleOutput.pdf';

      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();

      return response;
    }
  } catch (e) {
    return {
      error: true,
      message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
      status: e?.response?.status || 500,
    };
  }
}

}
